var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchmag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 80,
    viewBox: "0 0 77 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0818 66.2836C51.2049 70.3601 44.0687 72.749 36.3745 72.749C16.2854 72.749 0 56.4636 0 36.3745C0 16.2854 16.2854 0 36.3745 0C56.4636 0 72.749 16.2854 72.749 36.3745C72.749 46.1351 68.9046 54.9978 62.6474 61.5309L75.6031 73.7125C77.0667 75.0886 77.1376 77.3906 75.7615 78.8542C74.3854 80.3178 72.0834 80.3887 70.6198 79.0126L57.0818 66.2836ZM65.4736 36.3745C65.4736 52.4458 52.4453 65.4742 36.374 65.4742C20.3028 65.4742 7.27442 52.4458 7.27442 36.3745C7.27442 20.3033 20.3028 7.27493 36.374 7.27493C52.4453 7.27493 65.4736 20.3033 65.4736 36.3745Z",
    fill: "#6b6e72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchmag);
export default __webpack_public_path__ + "static/media/searchmag.4356577939996ffa3262cc8650f6e9b3.svg";
export { ForwardRef as ReactComponent };